import styled from "@emotion/styled";

export const InfoSection = styled.div`
  color: white;
  font-family: 'Inter', sans-serif;

  h3 {
    font-weight: bold;
    margin-bottom: 10px;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    margin-bottom: 6px;
    cursor: pointer;
    transition: color 0.3s ease;

    &:hover {
      color: #gray;
    }
  }
`;
